export default __webpack_public_path__ + "static/media/reward-active.72febb97.svg";